import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ScreensViewComponent } from './view/screens-view.component';
import { QuestionStandardComponent } from './view/question-standard/question-standard.component';
import { QuestionHeadingComponent } from './view/question-heading/question-heading.component';
import { QuestionCaseDataComponent } from './view/question-case-data/question-case-data.component';
import { QuestionConditionalComponent } from './view/question-conditional/question-conditional.component';
import { QuestionUnknownComponent } from './view/question-unknown/question-unknown.component';
import { QuestionNonInteractiveComponent } from './view/question-non-interactive/question-non-interactive.component';
import { BooleanInputComponent } from './controls/boolean-input.component';
import { DateInputComponent } from './controls/date-input.component';
import { DisclosureSearchInputComponent } from './controls/disclosure-search-input.component';
import { MultiSelectInputComponent } from './controls/multi-select-input.component';
import { NoteInputComponent } from './controls/note-input.component';
import { NumericInputComponent } from './controls/numeric-input.component';
import { PicklistInputComponent } from './controls/picklist-input.component';
import { ReflexivePicklistInputComponent } from './controls/reflexive-picklist-input.component';
import { SelectInputComponent } from './controls/select-input.component';
import { TextInputComponent } from './controls/text-input.component';
import { InterviewBootstrapComponent } from './interview-bootstrap/interview-bootstrap.component';
import { screensInterviewState } from './screens-interview.route';
import { PhysicianCaptureComponent } from './view/physician-capture/physician-capture.component';
import { QuestionsReflexiveComponent } from './view/questions-reflexive/questions-reflexive.component';
import { ScreensDemoSharedModule } from '../shared/shared.module';
import { SharedModule } from '@Shared/shared.module';
import { ShortDateInputComponent } from './controls/short-date-input.component';
import { MrasMaskDate2Directive, MrasMaskDateDirective } from './controls/mras-mask-date.directive';

@NgModule({
    imports: [SharedModule, ScreensDemoSharedModule, RouterModule.forChild(screensInterviewState)],
    exports: [ScreensViewComponent],
    declarations: [
        InterviewBootstrapComponent,
        ScreensViewComponent,
        QuestionStandardComponent,
        QuestionHeadingComponent,
        QuestionCaseDataComponent,
        QuestionConditionalComponent,
        QuestionsReflexiveComponent,
        QuestionUnknownComponent,
        QuestionNonInteractiveComponent,
        PhysicianCaptureComponent,
        BooleanInputComponent,
        DateInputComponent,
        ShortDateInputComponent,
        DisclosureSearchInputComponent,
        MultiSelectInputComponent,
        NoteInputComponent,
        NumericInputComponent,
        PicklistInputComponent,
        ReflexivePicklistInputComponent,
        SelectInputComponent,
        TextInputComponent,
        MrasMaskDateDirective,
        MrasMaskDate2Directive
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ScreensInterviewModule {}
